import React from 'react';
import PropTypes from "prop-types";

const PHONE = process.env.REACT_APP_PHONE ?? '';
const UNMASKED_PHONE = PHONE.replace(/\D/g, '');

const ContactAlert = ({ message = null }) => {
  return (
    <div className="mt-3">
      {message && (
        <p>
          {message}
        </p>
      )}
      <p>
        Entre em contato através do nosso WhatsApp <a href={`http://wa.me/55${UNMASKED_PHONE}`} target="_blank" rel="noopener noreferrer"><b>{PHONE}</b></a>
      </p>
    </div>
  )
}

ContactAlert.propTypes = {
  message: PropTypes.string,
}

export default ContactAlert
